import MDButton from "components/MDButton";

export const Export = ({ onExport }) => (
    <MDButton color="info" onClick={(e) => onExport(e.target.value)}>
      Descargar excel
    </MDButton>
  );